import Head from "next/head"
import DefaultLayout from "@/components/DefaultLayout"
import SliderBarLeft from "@/components/SliderBarLeft"
import SliderBarRight from "@/components/SliderBarRight"
import styles from "@/styles/article/return-policy.module.scss"
import Link from 'next/link'
import Image from 'next/image'

import getConfig from 'next/config'
const { publicRuntimeConfig } = getConfig()
const imageDomain = publicRuntimeConfig.imageDomain
export default function AboutUs() {

  return (
    <>
      <Head>
        <title>
          Online Shopping New Zealand - Beauty & Health, Computers, Toys, - Deals & Discounts | BestDeals
        </title>
        <meta
          name="keywords"
          content="Online Shopping New Zealand, online shopping sites, Home Shopping, Shopping Deals, Best Deals, Home Garden, Pet Supplies, Sports Fitness, Bedding Bath, Buy Online, Discount Shopping, Toys Hobbies, Beauty Health, Crazy Sales, Computers, IT, Christmas, Electronics, Automotive, Tools, Appliances, Baby, BestDeals"
        ></meta>
        <meta
          name="description"
          content="Offers the best online shopping in New Zealand with cheap deals on home & garden, appliances, pet supplies, fitness equipment & much more online. Check out our daily sales now!"
        ></meta>
      </Head>

      <DefaultLayout >
        <div className={`${styles['page-return-policy']}`}>
          <SliderBarLeft></SliderBarLeft>
          <SliderBarRight></SliderBarRight>

          <div className={styles['content']}>
            <div className={styles['content-title']}>About Us</div>

            <div className={`${styles['answer-desc']} padding-top-10`}>
              {`Welcome to BestDeals.co.nz `}
              {` Find the best products and get the best prices and the best service in New Zealand! Our considerable range of products features just about any gadget, household appliance, luxury item and gift idea you can wish for. Baby products, furniture, sporting goods and much more are available at everyday low prices. Find something for everyone at BestDeals.co.nz.`}
            </div>
            <div className={`${styles['answer-desc']} padding-top-10`}>
              {`At BestDeals our goal is to make sure you get the best deals with a pleasant, efficient shopping experience. We offer not only offer great prices on high-quality products but we also offer high-quality service. Our 10 years of experience as an New Zealand online retailer have allowed us to forge solid relationships with a number of manufacturers to get superior quality products at huge discounts. We work directly with manufacturers and no middlemen to offer up to 80% lower than retail prices. And now we bring those savings to New Zealand. We look for the best products at the best prices.`}
            </div>
            <div className={`${styles['answer-desc']} padding-top-10`}>
              {`At Best Deals we not only save you money, we reward you while you save. With our amazing discounts comes our amazing loyalty program that provides the opportunity for even more discounts on our already low prices. For every dollar you spend, we reward you with one point; accumulate your points and turn them in to coupons to get discounts on your orders. We offer multiple opportunities to earn points!`}
            </div>
            <div className={`${styles['answer-desc']} padding-top-10`}>
              {`With our warehouse located in Auckland, and orders dispatched the next business day our customers receive their products quickly and without delay. The moment your order is shipped you are provided with a tracking number to keep you current on the exact location of your package.`}
            </div>
            <div className={`${styles['answer-desc']} padding-top-10`}>
              {`We promise safe secure shopping on our site, so our customers can rest assured that all transactions are protected. We respect the privacy of our customers and will never pass your details on to a third party. Browse our inventory and buy without risk.`}
            </div>
            <div className={`${styles['answer-desc']} padding-top-10`}>
              <h2 style={{fontWeight:'bold'}}>Why shop at Best Deals?</h2>
              <p>{`Direct Imports – Save Up To 80%`}</p>
              <p>{`30 Days Money Back Guarantee`}</p>
              <p>{`12 Months Return to Base Warranty`}</p>
              <p>{`Fast Shipping – Dispatched The Next Business Day`}</p>
              <p>{`Reward Program—Save Chances to Save`}</p>
            </div>
          </div>
        </div>
      </DefaultLayout>
    </>
  )
}